import request from './http';
import { setEncrypt } from '../utils/encrypt';
const baseURL = process.env.VUE_APP_BASE_API;

// 获取登录页仓库列表
export function getNewLoginWarehouseList(data) {
  return request({
    url: '/owms/warehouse/enter/queryWarehouseCodeByUserName',
    method: 'get',
    params: data,
    baseURL
  })
}

export function loginInOWMS(data) {
  return request({
    url: '/owms/warehouse/enter/login',
    method: 'post',
    data,
    baseURL

  })
}
export function cutWarehouseCode(token, params) {
  const url = '/owms/warehouse/enter/cutWarehouseCode';
  let newToken = setEncrypt(`${token}###${url}`)

  return request({
    url,
    method: 'get',
    params,
    baseURL,
    headers: {
      clientType: "OWMS",
      cookieToken: newToken,
    }
  })
}